export default __webpack_public_path__ + "static/media/uman12.2f3331cc.png";